export const RELATIONSHIP_EMPLOYER = "R2";
export const RELATIONSHIP_SPOUSE = "R1";
export const RELATIONSHIP_SISTER_COMPANY = "R3";
export const RELATIONSHIP_OTHERS = "R4";

export const YES_NO_NA_OPTIONS = [
  {
    key: "Y",
    code: "Y",
    displayText: "Yes",
    value: "Y",
    subGroup: null
  },
  {
    key: "N",
    code: "N",
    displayText: "No",
    value: "N",
    subGroup: null
  },
  {
    key: "NA",
    code: "NA",
    displayText: "NA",
    value: "NA",
    subGroup: null
  }
];
